import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, Card, Spinner, Table } from 'react-bootstrap';
import { API_BASE_URL, getBearerToken } from '../../../functions';
import axios from 'axios';
import AddSector from '../../Modals/AddSector';
import SectorTRLoop from './SectorTRLoop';

// images import
import arrowicon from '../../../images/arrowicon.svg';
import userlogo from '../../../images/avatarpic3.jpg';
import arrowlefticon from '../../../images/arrowlefticon.svg';

const Sectors = () => {
  const [sectors, setSectors] = useState()
  const [show, setShow] = useState(false)
  const [apiData, setApiData] = useState('')
  const [loading, setloading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/listofsectors?page=${currentPage}`, {
      headers: {
        'Authorization': `Bearer ${getBearerToken()}`
      }
    }).then(response => {
      // Handle the response data
      if (currentPage === 1) {
        setSectors(response?.data?.data?.data)
      } else {
        setSectors(preData => [...preData, ...response?.data?.data?.data]);
      }
      setloading(false)
      setApiData(response?.data?.data);
    }).catch(error => {
      // Handle errors
      console.error(error);
      setloading(false)
    });
  }, [currentPage])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const handelshow = (e) => {
    e.preventDefault()
    setShow(true);
  }

  const nextPage = () => {
    if (apiData.next_page_url) {
      setCurrentPage(currentPage + 1);
      setloading(true)
    }
  };

  const prevPage = () => {
    if (apiData.prev_page_url) {
      setCurrentPage(currentPage - 1);
      setSectors(preData => preData.slice(0, -apiData.per_page));
      setloading(true)
    }
  };



  return (
    <>
      <div className={'main_heading mb-4 d-flex align-items-center'}>
        <h4>Sectors</h4>
        <Link to={'#'} className='ms-auto btn greenbg text-white fontsize14 fontweight700' style={{ minWidth: '160px', maxWidth: '160px' }} onClick={handelshow}>Add New sector</Link>
      </div>
      {/*  */}
      <Card className='' style={{ boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)' }}>
        <Card.Header className='px-3 px-lg-4 py-3' style={{ background: 'transparent', border: 'none', }}><h5 className={'fontsize18 blacktext fontweight600'}>All Sectors</h5></Card.Header>
        <Card.Body className={'p-0 mb-3'}>
          <Table responsive={'sm'} className={'mb-0 allView'}>
            <thead className={'thead-dark'}>
              <tr>
                <th>Sector</th>
                <th>From</th>
                <th>From-City</th>
                <th>To</th>
                <th>To-City</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {sectors && sectors.map((val, i) => {
                return (
                  <SectorTRLoop
                    key={i}
                    id={val.id}
                    sector_name={val.sector_name}
                    from_sector={val.from_sector}
                    from_city={val.from_city}
                    to_sector={val.to_sector}
                    to_city={val.to_city}
                    badgeText={val.badgeText}
                    badgeBG={val.badgeBG}
                    status={val.status}
                  />
                )
              })}
            </tbody>
          </Table>
          {!sectors || loading &&(
            <div className={'mt-3 w-100 text-center'}>
              <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />
            </div>
          )}
        </Card.Body>
        <Card.Footer className='px-3 px-lg-4 py-3 text-end' style={{ background: 'transparent', }}>
          <div className="d-flex align-items-center justify-content-end">
            <Badge bg={''} className={'p-2 py-1 gradiant2bg greentext'}>{sectors && sectors?.length} <span className='blacktext'>of</span> {apiData?.total}</Badge>
            <p className='p-0 m-0 fontsize12 blacktext fontweight500 mx-3'>Per Page : {apiData?.per_page} </p>
            <Button to={'#'} className={'fontsize14 footerbtn blacktext fontweight600 text-decoration-none  whitebg border-0'} onClick={prevPage} disabled={!apiData.prev_page_url}><img className={'img-fluid'} src={arrowlefticon} alt={'icon'} /></Button>
            <span>{currentPage}</span>
            <Button to={'#'} className={'fontsize14 footerbtn blacktext fontweight600 text-decoration-none  whitebg border-0'} onClick={nextPage} disabled={!apiData.next_page_url}><img className={'img-fluid'} src={arrowicon} alt={'icon'} /></Button>
          </div>
        </Card.Footer>
      </Card>
      {show &&
        <AddSector show={show} setShow={setShow} />
      }
    </>
  )
}

export default Sectors;